import axios from "axios";
import api from "..";
import API_ENDPOINTS from "../endpoints";

export const getPrimarySportDetails = async () => {
  const response = await api({
    method: "GET",
    url: API_ENDPOINTS.PRIMARY_SPORT_DETAILS,
  });

  return response.data;
};

export const addEarlyAccessUser = async (data) => {
  const response = await api({
    method: "POST",
    url: API_ENDPOINTS.EARLY_ACCESS_ADD_USER,
    data: data,
  });

  return response.data;
};

export const postEarlyAccessVerifyOtp = async (data) => {
  const response = await api({
    method: "POST",
    url: API_ENDPOINTS.EARLY_ACCESS_VERIFY_OTP,
    data: data,
  });

  return response.data;
};

export const postEarlyAccessResendOtp = async (data) => {
  const response = await api({
    method: "POST",
    url: API_ENDPOINTS.EARLY_ACCESS_RESEND_OTP,
    data: data,
  });

  return response.data;
};

export const getIP = async () => {
  const response = await axios.get("https://api.ipify.org?format=json");
  return response.data;
};
